import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import "@fullcalendar/core/main.min.css";
import siLocale from "@fullcalendar/core/locales/sl";
import googleCalendarPlugin from "@fullcalendar/google-calendar";
import { Dialog } from "@reach/dialog";
import './calendar.scss'
import "@reach/dialog/styles.css";

function createShareLink(id) {
  // return `https://calendar.google.com/calendar/ical/${id}/public/basic.ics`;
  return `https://calendar.google.com/calendar/embed?src=${id}&ctz=Europe%2FBelgrade`;
}
let allEvents = [
  {
    googleCalendarId: "p27gdpqco5beon253rllakp95c@group.calendar.google.com",
    id: "os-iroba",
    backgroundColor: '#178ee2',
    title: "Osnovna sola Ivana Roba"
  },
  {
    googleCalendarId: "b4re3obe759422q57unen346rc@group.calendar.google.com",
    id: "vrtec-iroba",
    backgroundColor: 'orange',
    title: "Vrtec Ivana Roba"
  }
];
export default class MyCalendar extends React.Component {
  state = {
    event: null,
    events: allEvents
  };

  onDateClick = ({ jsEvent, event }) => {
    jsEvent.preventDefault();
    this.setState({
      event
    });
  };

  renderPopup(event) {
    const {
      title,
      extendedProps: { description },
      start,
      end
    } = event;
    // console.log(start)
    const from = new Date(start)
    const to = new Date(end)
    const SI = 'sl-SL'
    return (
      <Dialog
        isOpen={event !== null}
        onDismiss={() => this.setState({ event: null })}
      >
        <button
          className="close-button"
          onClick={() => this.setState({ event: null })}
        >
          <span aria-hidden>×</span>
        </button>
        <h3>{title}</h3>
        Od: {from.toLocaleDateString(SI)}, {from.toLocaleTimeString(SI)} | Do {end.toLocaleDateString(SI)}, {end.toLocaleTimeString(SI)}
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </Dialog>
    );
  }

  toggleEvents = index => {
    const { events } = this.state;
    const clicked = events[index];
    clicked.disabled = !clicked.disabled;
    this.setState({ events });
  };
  render() {
    const { event, events } = this.state;
    const { showLegend = true } = this.props;
    const bla = events.filter(evt => !evt.disabled);
    return (
      <div className="calendarWrap">
        <FullCalendar
          height={this.props.height || 700}
          defaultView="dayGridMonth"
          dateClick={this.onDateClick}
          eventClick={this.onDateClick}
          locale={siLocale}
          plugins={[dayGridPlugin, googleCalendarPlugin]}
          googleCalendarApiKey="AIzaSyCd9Kxun2IgueqbieirCviJUEUMlWPoFR8"
          eventSources={bla}
        />
        {showLegend && (
          <div className="legend">
            <h2>Legenda</h2>
            {events.map((evt, i) => {
              return (
                <div>
                  <label>
                    <div className="legendIcon" style={{background: evt.backgroundColor}} />
                    <input
                      type="checkbox"
                      checked={!evt.disabled}
                      onChange={() => this.toggleEvents(i)}
                    />
                    {evt.title}
                  </label>
                  <a href={createShareLink(evt.googleCalendarId)}>Prijavi se</a>
                </div>
              );
            })}
          </div>
        )}
        {event && this.renderPopup(event)}
      </div>
    );
  }
}
